<template>
  <fade-transition :duration="300" mode="out-in">
    <div class="card-flight">
      <label for="card-flight" class="title-label" v-if="mode === 'edit'">
        Selected Flight
      </label>
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            <div class="content-flight">
              <div>
                <span class="label-from-to">Departure</span>
                <span class="airport-code">
                  {{ flight.origin.airport_code }}
                </span>
              </div>

              <div>
                <span class="location">
                  {{ flight.origin.name }}
                  <br />
                  {{ flight.origin.location }}
                </span>
              </div>

              <div>
                <span class="flight-time">
                  {{ formatDate(flight.departuretime, flight.origin.timezone) }}
                  <br />
                  {{ formatTime(flight.departuretime, flight.origin.timezone) }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-6 border-left-dashed">
            <div class="content-flight">
              <div>
                <span class="label-from-to">Arrival</span>
                <span class="airport-code">
                  {{ flight.destination.airport_code }}
                </span>
              </div>

              <div>
                <span class="location">
                  {{ flight.destination.name }}
                  <br />
                  {{ flight.destination.location }}
                </span>
              </div>

              <div>
                <span class="flight-time">
                  {{
                    formatDate(flight.arrivaltime, flight.destination.timezone)
                  }}
                  <br />
                  {{
                    formatTime(flight.arrivaltime, flight.destination.timezone)
                  }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="warning-flight border-top">
              <span v-if="flight.isAdjustingDateTime">
                <i class="flaticon-warning mr-1"></i>
                Flight validated successfully. Pickup date and time were updated
                based on the flight information
              </span>
              <span v-else>
                <i class="flaticon-warning mr-1"></i>
                Flight validated successfully. The system detected a different
                pickup date and time, but the original values were kept as
                entered.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fade-transition>
</template>

<script>
import { FadeTransition } from "vue2-transitions";
import { formatDate, formatTime } from "../../services/flight.service";
export default {
  name: "FlightDetails",
  props: {
    flight: {
      type: Object,
      required: false,
      default: () => ({})
    },
    mode: {
      type: String,
      required: false,
      default: "view" //view o edit
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    formatDate,
    formatTime
  },
  components: {
    FadeTransition
  }
};
</script>
